import React from 'react';

export type CccWorkspaceDuplicateFlags = {
  duplicate_phone?: boolean;
  duplicate_nif?: boolean;
};

const buildTitle = (flags: CccWorkspaceDuplicateFlags): string => {
  const parts: string[] = [];
  if (flags.duplicate_phone) parts.push('contacto telefónico');
  if (flags.duplicate_nif) parts.push('NIF');
  if (parts.length === 0) return '';
  return `Outro lead ou marcação com o mesmo ${parts.join(' e/o ')}`;
};

type Props = {
  flags?: CccWorkspaceDuplicateFlags | null;
  className?: string;
};

const CccWorkspaceDuplicateIndicator: React.FC<Props> = ({ flags, className = '' }) => {
  if (!flags?.duplicate_phone && !flags?.duplicate_nif) return null;
  const title = buildTitle(flags);
  const labels: string[] = [];
  if (flags.duplicate_phone) labels.push('Tel.');
  if (flags.duplicate_nif) labels.push('NIF');
  return (
    <span
      className={`ccc-dup-indicator ${className}`.trim()}
      role="img"
      aria-label={title}
      title={title}
    >
      <span className="ccc-dup-indicator__icon" aria-hidden>
        ⧉
      </span>
      <span className="ccc-dup-indicator__label">{labels.join(' · ')}</span>
    </span>
  );
};

export default CccWorkspaceDuplicateIndicator;
